import { FetchAction, FetchActionCreator } from '../fetch/model'

export type ResourceSelectedAction<T> = {
  type: string,
  payload: { selected?: T },
  origin?: string
}

export type ResourcesSelectedAction<T> = {
  type: string,
  payload: { resources?: T[] },
  origin?: string
}

export type SelectorAction<T> =
  | FetchAction<T[]>
  | ResourceSelectedAction<T>
  | ResourcesSelectedAction<T>

export type SelectorActionCreator<T> = FetchActionCreator<T[]> & {
  resourceSelected: (resource?: T) => ResourceSelectedAction<T>
  resourcesSelected: (resources?: T[]) => ResourcesSelectedAction<T>
}

export type SelectorOption = {
  label: string
  value: string
}

export const isResourceSelectedAction = <T>(action: SelectorAction<T>): action is ResourceSelectedAction<T> => {
  return (action as ResourceSelectedAction<T>).type.endsWith('_SELECTED')
}

export const isResourcesSelectedAction = <T>(action: SelectorAction<T>): action is ResourcesSelectedAction<T> => {
  return (action as ResourceSelectedAction<T>).type.endsWith('_MULTI_SELECTED')
}
